import { render, staticRenderFns } from "./wxToolLog.vue?vue&type=template&id=32e3991d"
import script from "./wxToolLog.vue?vue&type=script&lang=js"
export * from "./wxToolLog.vue?vue&type=script&lang=js"
import style0 from "./wxToolLog.vue?vue&type=style&index=0&id=32e3991d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports